// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {HeadercourseModuleLayout} from 'app_components/modules/academic/headercourse'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @ADD Component types
interface IHeadercourseModuleProps {
  type: string
  course: ICourse | null
}
interface IHeadercourseModuleState {
  // loading: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class HeadercourseModule extends Component<IHeadercourseModuleProps, IHeadercourseModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IHeadercourseModuleProps) {
    super(props)
    this.state = {
      // loading: true
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <HeadercourseModuleLayout
        type={this.props.type}
        course={this.props.course}
      />
    )
  }
}

export default connect(mapStatesToProps)(HeadercourseModule)
